import type { CityConfig } from "../city-template/types";

export const northglennConfig: CityConfig = {
  city: "Northglenn",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "northglenn",
  route: "/cities/northglenn",
  title: "Emergency & Expedited Passport Northglenn CO | Same-Day Adams County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Northglenn, Colorado — as fast as 24 hours. Same-day courier processing for Northglenn, Thornton, Westminster, Broomfield, and all northern Adams County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Northglenn, CO",
  heroSubtitle: "Family vacation to Mexico coming up and your passport is expired? Business trip to Canada next week? We help Northglenn residents — from Webster Lake families to I-25 corridor commuters to Adams County professionals — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Northglenn%20Colorado%20suburban%20landscape%20with%20Webster%20Lake%20and%20its%20surrounding%20walking%20paths%20and%20green%20spaces%2C%20modern%20residential%20neighborhoods%20with%20mature%20trees%2C%20the%20Front%20Range%20Rocky%20Mountains%20visible%20on%20the%20western%20horizon%20under%20a%20bright%20blue%20Colorado%20sky%2C%20the%20I-25%20corridor%20with%20suburban%20development%2C%20warm%20golden%20afternoon%20light%20casting%20long%20shadows%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20natural%20suburban%20tones&width=1800&height=700&seq=northglenn-hero-001&orientation=landscape",
  heroImageAlt: "Northglenn Colorado with Webster Lake and Front Range mountain views across the northern Denver suburbs",
  geoPosition: "39.8955;-104.9870",
  geoPlacename: "Northglenn, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 25 miles southeast via I-25 and I-225 — about 30–40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Northglenn", zips: "80233, 80234, 80260" },
    { name: "Thornton", zips: "80241, 80602, 80229" },
    { name: "Westminster", zips: "80031, 80030, 80021" },
    { name: "Broomfield", zips: "80020, 80021, 80023" },
    { name: "Federal Heights", zips: "80260" },
    { name: "Commerce City", zips: "80022, 80037" },
    { name: "Brighton", zips: "80601, 80602" },
    { name: "Denver", zips: "80216, 80221, 80211" },
    { name: "Arvada", zips: "80002, 80003, 80005" },
    { name: "Eastlake", zips: "80602" },
    { name: "Welby", zips: "80229" },
    { name: "Erie", zips: "80516" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Northglenn international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora entirely" },
    { icon: "ri-flight-takeoff-line", title: "DIA Access via I-25", desc: "Convenient I-25 corridor access to Denver International Airport" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Northglenn, Thornton, or Westminster" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Thornton, CO", route: "/cities/thornton" },
    { name: "Fast passport renewal in Northglenn area", route: "/cities/northglenn" },
    { name: "Urgent passport services for Westminster and Broomfield", route: "/cities/westminster-co" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Brighton and Commerce City", route: "/cities/brighton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Northglenn remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Northglenn's prime location along the I-25 corridor — just 25 miles from the Denver Passport Agency — makes our courier service the smartest choice. Skip the drive through congested metro Denver traffic and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Northglenn, Federal Heights, and the northern I-25 corridor communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Northglenn and the surrounding northern metro area. From the neighborhoods around Webster Lake and E.B. Rains Jr. Memorial Park to the communities along 104th Avenue and the I-25 corridor, from the original Northglenn neighborhoods to the newer developments near the Thornton border — we serve every corner of Northglenn.",
  nearbyCitiesIntro: "We serve Northglenn and all nearby communities including Thornton, Westminster, Broomfield, Federal Heights, Commerce City, Brighton, Arvada, and the northern Denver suburbs.",
  howItWorksIntro: "Most Northglenn travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to navigate I-25 and I-225 through metro Denver.",
  mistakesIntro: "Northglenn is a well-established northern suburb with families, commuters, and long-time residents. Here are the most common passport mistakes we see from Northglenn-area travelers.",
  testimonialsIntro: "Northglenn travelers — from families near Webster Lake to I-25 corridor commuters to long-time Adams County residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Northglenn, CO? Here are the most common ones we hear from northern metro travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (30–40 minutes each way)", "I-25/I-225 interchange is a known bottleneck"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Northglenn", "Perfect for family vacations and business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Northglenn travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without fighting metro Denver traffic on I-25 and I-225.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support via I-25 corridor", "Family and business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Northglenn adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Northglenn address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Northglenn residents and Adams County families — including young adults and new citizens.",
      bullets: ["Acceptance facility scheduling in Northglenn or Thornton", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Northglenn residents who lost their passport before international travel — business or vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Northglenn and northern metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Northglenn and Adams County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Northglenn CO", description: "Urgent passport processing for Northglenn Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Northglenn CO", description: "Fast passport renewal for Northglenn Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Northglenn CO", description: "New passport application services for Northglenn Colorado residents applying for their first passport." },
    { name: "Child Passport Northglenn CO", description: "Minor passport services for Northglenn Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Patricia H.",
      location: "Northglenn, CO — Near Webster Lake",
      rating: 5,
      text: "Family cruise departing from Fort Lauderdale and we realized our daughter's passport had expired just 5 days before. Fast Passport Center handled the emergency renewal in 3 days. Shipped from the UPS Store on 104th and everything was perfect.",
      service: "Emergency Child Passport Renewal",
    },
    {
      name: "Kevin M.",
      location: "Northglenn, CO — Fox Run",
      rating: 5,
      text: "Business trip to London with a week's notice. My passport was damaged and I was panicking. Fast Passport Center got me a new one in 4 days. The courier service is a game-changer — I didn't have to deal with a single minute of I-25 traffic.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Amanda R.",
      location: "Northglenn, CO — Victoria Heights",
      rating: 5,
      text: "First-time passports for our family of four heading to Costa Rica. Fast Passport Center walked us through everything and got all four passports in 6 days. Incredible service — so much easier than dealing with the post office.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tony G.",
      location: "Federal Heights, CO",
      rating: 5,
      text: "Needed a passport for a last-minute trip to see family in Guadalajara. Fast Passport Center handled the renewal in 48 hours. Being right off I-25, I was able to get to DIA with no problems.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "ng-1",
      name: "Northglenn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11887 Washington St",
      city: "Northglenn",
      state: "CO",
      zip: "80233",
      phone: "(303) 451-1666",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Northglenn, near Washington Street and 120th Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Northglenn acceptance facility. Appointments recommended — call ahead. Serves Northglenn and Federal Heights residents.",
      icon: "ri-mail-line",
    },
    {
      id: "ng-2",
      name: "Thornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8700 Grant St",
      city: "Thornton",
      state: "CO",
      zip: "80229",
      phone: "(303) 853-9940",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 5 miles east of Northglenn, in Thornton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with extended hours (open until 5PM). Good alternative when Northglenn appointments are full. Serves the northern I-25 corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "ng-3",
      name: "Westminster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7351 Federal Blvd",
      city: "Westminster",
      state: "CO",
      zip: "80030",
      phone: "(303) 426-5911",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles southwest of Northglenn, in Westminster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility for the Northglenn-Westminster corridor. Convenient for residents near the 104th Avenue corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "ng-4",
      name: "Broomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2800 W 120th Ave",
      city: "Broomfield",
      state: "CO",
      zip: "80020",
      phone: "(303) 466-0170",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles northwest of Northglenn, in Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility for Northglenn-Broomfield corridor residents. Located near the Flatiron Crossing area. Good parking availability.",
      icon: "ri-mail-line",
    },
    {
      id: "ng-5",
      name: "Adams County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "4430 S Adams County Pkwy",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(720) 523-6100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Approximately 15 miles northeast of Northglenn, in Brighton",
      website: "https://www.adamscountyco.gov/",
      websiteLabel: "Adams County Clerk",
      notes: "County government passport acceptance at the Adams County Government Center. Early morning hours at 8AM. Serves all Adams County residents including Northglenn.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora via I-25/I-225", fpc: "No — ship from Northglenn" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25/I-225 Interchange", agency: "Major traffic bottleneck during rush hour", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Travel Season",
      description: "Northglenn families often wait until summer or winter break to check passports. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your trip — especially during June–August and November–January.",
    },
    {
      icon: "ri-image-line",
      title: "Using Outdated Passport Photos",
      description: "Northglenn photo services at grocery stores may not follow the latest requirements. Passport photos must be exactly 2×2 inches on a white or off-white background, taken within 6 months, with no glasses and a neutral expression.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Checking Northglenn Post Office Availability",
      description: "The Northglenn Post Office on Washington Street is a smaller facility with limited passport appointment slots. During peak seasons, book 2–3 weeks ahead or use nearby Thornton or Westminster facilities.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating I-25/I-225 Interchange Traffic",
      description: "Driving from Northglenn to the Aurora passport agency requires navigating the I-25/I-225 interchange — one of metro Denver's most congested areas. Rush hour can easily double the drive time.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Country-Specific Entry Requirements",
      description: "Beyond the 6-month validity rule, many countries have additional requirements like blank visa pages or specific visa types. Northglenn travelers heading to Latin America or Asia often miss these details.",
    },
    {
      icon: "ri-parent-line",
      title: "Forgetting Both Parents Must Be Present for Minors",
      description: "For children under 16, both parents or guardians must appear in person at the acceptance facility or provide notarized consent. Northglenn families often arrive with only one parent, causing delays.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Northglenn or the northern metro area." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Northglenn, Thornton, or Westminster." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Adams County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25/I-225 interchange battle required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Northglenn address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Northglenn, CO?", a: "Fast Passport Center offers emergency passport processing in Northglenn, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to navigate the I-25/I-225 interchange to the Aurora passport agency." },
    { q: "Does Northglenn have its own passport agency?", a: "No — Northglenn does not have a regional passport agency. The nearest is the Denver Passport Agency in Aurora (25 miles southeast via I-25 and I-225). Fast Passport Center's courier service means Northglenn residents never need to deal with metro Denver traffic." },
    { q: "What acceptance facilities are available in Northglenn?", a: "The Northglenn Post Office (11887 Washington St) offers passport acceptance services. Nearby options include Thornton Post Office (5 miles east), Westminster Post Office (5 miles southwest), and the Adams County Clerk in Brighton (15 miles northeast). Each has different hours and appointment availability." },
    { q: "What if I live in Federal Heights or the northern Denver suburbs?", a: "Absolutely. Fast Passport Center serves all of Northglenn and the surrounding communities including Federal Heights, Welby, and the northern Denver suburbs that border Northglenn. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "Can you help with passports for Northglenn commuters traveling internationally for work?", a: "Yes. Fast Passport Center serves Northglenn's professional workforce — many of whom commute to Denver, Boulder, or the DTC corridor. We understand the scheduling challenges of working professionals and can coordinate expedited services around your work calendar." },
    { q: "How much does an expedited passport cost in Northglenn, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Northglenn?", a: "Walgreens (10500 Melody Dr) and King Soopers (500 E 120th Ave) offer passport photo services in Northglenn. UPS Store and FedEx Office locations in nearby Thornton and Westminster also provide photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Northglenn-Thornton-Westminster tri-city area?", a: "Yes. Fast Passport Center serves the entire Northglenn, Thornton, and Westminster corridor along I-25. Our courier service covers the full northern metro area including Broomfield, Federal Heights, and all surrounding Adams, Jefferson, and Broomfield county communities." },
  ],
  photoLocations: [
    { name: "Walgreens — Northglenn", address: "10500 Melody Dr, Northglenn, CO 80234", hours: "Mon–Sun: 8AM–9PM" },
    { name: "King Soopers — Northglenn", address: "500 E 120th Ave, Northglenn, CO 80233", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Thornton", address: "3901 E 120th Ave, Thornton, CO 80233", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "FedEx Office — Westminster", address: "7353 Federal Blvd, Westminster, CO 80030", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Thornton (Adams County)", address: "11940 Colorado Blvd, Thornton, CO 80233", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV in Thornton for northern Adams County residents. REAL ID and driver's license renewals. Approximately 5 miles from Northglenn with easy access from 120th Avenue.", featured: true },
    { name: "DMV — Westminster (Jefferson County)", address: "8452 Federal Blvd, Westminster, CO 80031", hours: "Mon–Fri: 8AM–5PM", note: "DMV serving Jefferson County residents in the Northglenn-Westminster corridor. REAL ID processing available. Convenient Federal Boulevard access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "25 miles southeast via E-470 — approximately 25–30 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Convenient for Northglenn residents via the I-25/E-470 corridor.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "15 miles west via US-36 — approximately 20 minutes",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving the northern metro area. No scheduled commercial service. Private and charter flights only. Convenient for Northglenn via 120th Avenue.",
      flightUrl: "https://www.flyrmm.com/",
      flightLabel: "BJC Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Colorado Department of Public Health and Environment Vital Records in Denver — order certified birth and death certificates for Adams County residents.", url: "https://cdphe.colorado.gov/vital-records" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Adams County Clerk and Recorder — certified marriage licenses for name change passport applications.", url: "https://www.adamscountyco.gov/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Adams County District Court — certified divorce decrees supporting passport name change.", url: "https://www.courts.state.co.us/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "Order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};